import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { FilterFormModal, FilterValue } from 'src/app/models/form-group.model';
import { CommonService } from 'src/app/services/common.service';


@Component({
  selector: 'fury-post-lead-request-list',
  templateUrl: './post-lead-request-list.component.html',
  styleUrls: ['./post-lead-request-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class PostLeadRequestListComponent implements OnInit {

  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  @Input()
  columns = [
    { name: 'IP Address', property: 'ip', visible: true },
    {
      name: 'Requested at',
      property: 'requestedAt',
      visible: true,
      isModelProperty: true,
    },
    { name: 'Referred From', property: 'referralName', visible: true },
    {name: 'First Name', property: 'firstName', visible: true},
    {name: 'Last Name', property: 'lastName', visible: true},
    {name: 'Email', property: 'emailAddress', visible: true},
    {name: 'Phone No', property: 'mobileNumber', visible: true},
    { name: 'Status', property: 'status', visible: true },
    { name: 'Actions', property: 'actions', visible: true },
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  searchedKeyword!: string;
  notPostedLeadCount:any;
  searchBy: string = 'firstName';
  searchType: string = 'contains';
  isShowFilter: boolean = false;

  filterForm = new FormGroup<FilterFormModal>({
    searchBy: new FormControl(this.searchBy),
    searchType: new FormControl(this.searchType),
  });

  constructor(
    private apiservice: ApiService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public commonService: CommonService
  ) {
    this.filterValue = 'Post Lead Requests';
    this.router.onSameUrlNavigation = 'reload';

    this.activatedRoute.queryParams.subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1 : 0;
      this.searchedKeyword = res.keywords ? res.keywords : '';
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;
      this.searchBy = res.searchBy ? res.searchBy : 'firstName';
      this.searchType = res.searchType ? res.searchType : 'contains';
      this.filterForm.patchValue({
        searchBy: this.searchBy,
        searchType: this.searchType
      });     
      this.getLeadRequestList();
    });
  }
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  ngOnInit(): void {
  }

  
  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(
      `/security/post-lead-requests/view-all-post-lead-requests?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`
    );
    this.getLeadRequestList();
  }
  getLeadRequestList() {
    this.apiservice
      .get(
        `admin/security/lead-posting-filter/get-all-lead-requests?page=${this.pageIndex + 1}&size=${this.pageSize}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''
        }&type=postLead&searchBy=${this.searchBy}&searchType=${this.searchType}`
      )
      .subscribe((res: any) => {
        if (res.body) {
          this.notPostedLeadCount = res?.body?.notPostedLeadCount;
          if (res.body.leads.data) {
            this.itemList = res.body.leads.data;
            this.totalCount = res.body.leads.total;
            this.dataSource = new MatTableDataSource(this.itemList);
            this.cdr.detectChanges();
          } else {
            this.itemList = undefined;
          }
        }
      });
  }

  onFilterChange(value: string) {
    this.pageIndex = 0;
    this.searchedKeyword = value.trim();
    this.router.navigateByUrl(
      `/security/post-lead-requests/view-all-post-lead-requests?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`
    );
    this.getLeadRequestList();
  }

  proceessRequest(row: any) {
    this.apiservice
      .patch(
        `admin/security/lead-posting-filter/allow-lead-request/${row?.leadId}`
      )
      .subscribe((res: any) => {
          if (res.body) {
            this.apiservice.alert(res.body.message, 'success');
            this.getLeadRequestList();
          } else {
            this.itemList = undefined;
            this.apiservice.alert(res.body.message, 'warning');
          }
      }, err => {
        this.apiservice.alert(err.message, 'error');
      });
  }
  navigateToLeadDetailsPage(data:any){
    this.router.navigateByUrl('/lead/lead-details/'+ data.leadId + '?type=customerInformation');
  }
  postUnPostedLead(){
    this.apiservice.patch('admin/lead/post-all-un-posted-leads-to-vanilla-soft').subscribe((res:any)=>{
      if(res?.body){
        this.getLeadRequestList();
        this.apiservice.alert(res?.body?.message, 'success');
      }
    }, err =>{
      this.apiservice.alert('Please try again', 'error');
    })
  }
  ngOnDestroy() { }

  showFilter(){
    this.isShowFilter = !this.isShowFilter; 
  }
  serchByValue: FilterValue[] = [
    {title: 'First Name', value: 'firstName'},
    {title: 'Last Name', value: 'lastName'},
    {title: 'Ip Address', value: 'ipAddress'},
    {title: 'Email Address', value: 'emailAddress'},
    {title: 'Phone Number', value: 'mobileNumber'},
  ];
  filterChange(){
    this.searchType = this.filterForm.value.searchType;
    this.searchBy = this.filterForm.value.searchBy;
    this.router.navigateByUrl(`/security/post-lead-requests/view-all-post-lead-requests?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.isShowFilter = false;
    this.getLeadRequestList();
  }

}
